// extracted by mini-css-extract-plugin
export var alignLeft = "q_rh d_fp d_bG d_dv";
export var alignCenter = "q_bP d_fq d_bD d_dw";
export var alignRight = "q_rj d_fr d_bH d_dx";
export var customRow = "q_qL d_bD d_Z";